import './FinanceExample.scss';

import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { useTheme } from '../../../hooks/useTheme';
import TRANSLATIONS from '../../../translations/translations@default.json';
import PatternLeft from './PatternLeft';
import PatternRight from './PatternRight';

export const FinanceExample = () => {
	const theme = useTheme('financeFooter');

	const isBelow543 = useMediaQuery({
		maxWidth: 543,
	});

	const isBelow768 = useMediaQuery({
		maxWidth: 768,
	});

	let viewBox = '0 0 153.86 123';

	if (isBelow543) {
		viewBox = '70 0 20 123';
	} else if (isBelow768) {
		viewBox = '0 0 133.86 123';
	}

	return (
		<div className="w-full max-w-screen-md md:mt-8">
			<div className={`flex md:rounded-md overflow-hidden ${theme.background}`}>
				<PatternLeft viewBox={viewBox} fill={theme.fill} />
				<div
					className="flex flex-col flex-grow items-center justify-center sm:px-4 py-4 sm:py-0"
					style={{ minHeight: '123px' }}>
					<p className={`text-body-xs mb-2 ${theme.text}`}>
						{TRANSLATIONS.listerFooter.financeExample.title}
					</p>

					<div className="flex items-center justify-between">
						{TRANSLATIONS.listerFooter.financeExample.examples.map(
							(example) => (
								<div key={example.title} className="px-2 sm:px-6">
									<span
										className={`text-title-sm whitespace-no-wrap ${theme.title}`}>
										{example.title}
									</span>
									<p
										className={`text-body-xs whitespace-no-wrap ${theme.text}`}>
										{example.description1}
										<br /> {example.description2}
									</p>
								</div>
							)
						)}
					</div>
				</div>
				<PatternRight viewBox={viewBox} fill={theme.fill} />
			</div>

			<div className="text-body-xs mt-4 px-2">
				<p>{TRANSLATIONS.listerFooter.financeExample.creditText}</p>
				<div className="font-bold">
					{TRANSLATIONS.listerFooter.financeExample.creditTextBold}
				</div>
			</div>
		</div>
	);
};

export default FinanceExample;
